// extracted by mini-css-extract-plugin
module.exports = {"title":"bookingSection_title__QpKSw","link":"bookingSection_link__lIqK_","operations":"bookingSection_operations__2hTcf","description":"bookingSection_description__L4ZQU"};